import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import ApiProvider  from '../../../../../core/api/ApiProvider';
import { Loader, Table } from '../../../../../core/components';
import { DataTable, emptyDataTable } from '../../../../../core/components/Table/types/DataTable';
import { InfoMessageService } from '../../../../../core/services';
import { ResponseApiType } from '../../../../types/ResponseApiType';

const Activities = () => {
  const { caseNumber, tenantUId } = useParams() as { caseNumber: string; tenantUId: string; };
  const [table, setTable] = useState<DataTable>({...emptyDataTable});
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [pageSizeLimit, setPageSizeLimit] = useState<number>(10);

  const fetchActivities = async () => {
    try {
      const result = await ApiProvider.post<ResponseApiType<{ rowsLimit: number; table: DataTable }>>('ActivitiesModule/GetActivities', { CaseNo: caseNumber });

      if (result.success) {
        const rows = result.data.table.dataRows.map(
          (h: any, index: number) => ({
            ...h,
            Id: `${h.ColumnName}${index}`,
          })
        );

        const headers = result.data.table.headers.map((h) => {
          let cssClassNames = '';

          if (h.columnName === 'Interest') {
            cssClassNames = 'to-right';
          }

          if (h.columnName === 'RemainingCapital') {
            cssClassNames = 'to-right';
          }

          if (h.columnName === 'Costs') {
            cssClassNames = 'to-right';
          }

          if (h.columnName === 'Paid') {
            cssClassNames = 'to-right';
          }

          return {
            ...h,
            cssClassNames: `${cssClassNames} ${!h.isVisible && 'hide-d'} ${
              !h.isVisibleOnMobile && 'hide-m'
            }`,
          }
        });

        headers.push({
          columnName: 'Id',
          headerName: '',
          isVisible: false,
          cssClassNames: '',
        });

        setTable({
          headers: headers,
          dataRows: rows,
        });
        setPageSizeLimit(result.data.rowsLimit);
      }
    } catch (err) {
      InfoMessageService.error('ErrorSthWentWrong');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchActivities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Table
            headers={table.headers}
            rows={table.dataRows}
            keyField="Id"
            paginationProps={{
              hideSizePerPage: true,
              hidePageListOnlyOnePage: true,
              sizePerPage: pageSizeLimit,
            }}
          />
        </>
      )}
    </>
  );
};

export default Activities;
